import React, { useState, useEffect } from "react";
import { Collapse, Container, NavbarToggler, NavLink } from "reactstrap";
import Scrollspy from "react-scrollspy";
import { Link } from "react-router-dom";
import ConnectMetamaskButton from "../../../Components/ConnectMetamaskButton";

// Import Images
import logodark from "../../../assets/images/logo-light.png";
import logolight from "../../../assets/images/logo-dark.png";

const Navbar = ({ networkConfig, setIsConnected, isConnected }) => {
  const [isOpenMenu, setisOpenMenu] = useState(false);
  const [navClass, setnavClass] = useState("");

  const toggle = () => setisOpenMenu(!isOpenMenu);

  useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true);
  });

  function scrollNavigation() {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      setnavClass("is-sticky");
    } else {
      setnavClass("");
    }
  }

  return (
    <React.Fragment>
      <nav
        className={
          "navbar navbar-expand-lg navbar-landing fixed-top " + navClass
        }
        id="navbar"
      >
        <Container>
          <Link className="navbar-brand" to="/">
            <img
              src={logodark}
              className="card-logo card-logo-dark"
              alt="logo dark"
              height="50"
            />
            <img
              src={logolight}
              className="card-logo card-logo-light"
              alt="logo light"
              height="50"
            />
          </Link>

          <NavbarToggler
            className="navbar-toggler py-0 fs-20 text-body"
            onClick={toggle}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="mdi mdi-menu"></i>
          </NavbarToggler>

          <Collapse
            isOpen={isOpenMenu}
            className="navbar-collapse"
            id="navbarSupportedContent"
          >
            <Scrollspy
              offset={-18}
              items={["hero"]}
              currentClassName="active"
              className="navbar-nav mx-auto mt-2 mt-lg-0"
              id="navbar-example"
            >
              <li className="nav-item">
                <NavLink className="fs-14 " href="https://fort.exchange">
                  Principal
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="fs-14" href="https://painel.fort.exchange">
                  Painel
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="fs-14"
                  href="https://api.whatsapp.com/send?phone=5516996188872&text=Ol%C3%A1,%20quero%20saber%20mais%20sobre%20a%20Fort%20P2P"
                >
                  WhatsApp
                </NavLink>
              </li>
            </Scrollspy>

            <div className="">
              <ConnectMetamaskButton
                networkConfig={networkConfig}
                setIsConnected={setIsConnected}
                isConnected={isConnected}
              />
            </div>
          </Collapse>
        </Container>
      </nav>
    </React.Fragment>
  );
};

export default Navbar;
